import https from "./url.js"

// 获取分类信息
export const Catelist = function(){
    // console.log(https.get('/one'))
    return https.get('/api/portal/index/Catelist')
}
// 获取二级分类信息
export const subCatelist = function(ids){
    // console.log(https.get('/one'))
    return https.get('/api/portal/index/subCategories?id='+ids)
}
// 产品详细信息
export const Detailsdata = function (ids) {
    // console.log(https.get('/one'))
    return https.get('/api/portal/index/Details?id='+ids)
}

// 产品列表
export const Listdata = function(ids){
    // console.log(https.get('/one'))
    return https.get('/api/portal/index/Productlist?category='+ids)
}
//同等分类推荐产品
export const Recommenddata = function(ids){
    // console.log(https.get('/one'))
    return https.get('/api/portal/index/recommend?category='+ids)
}


// WEBPACK FOOTER //
// ./src/api/Home.js